module.exports = fox._r("images/promo/mob-soc-yt.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/mob-soc-yt.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/mob-soc-yt.png
// module id = 175
// module chunks = 2